import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import { useCallback, useMemo } from "react";

const ParticlesBackground = (props) => {
  const options = useMemo(() => ({
    autoPlay: true,
    background: {
      color: { value: "transparent" },
    },
    fullScreen: {
      enable: true,
      zIndex: -1,
    },
    detectRetina: true,
    fpsLimit: 60,
    interactivity: {
      detectsOn: "window",
      events: {
        onHover: {
          enable: true,
          mode: "grab",
          parallax: { enable: true, force: 20, smooth: 30 },
        },
        resize: { enable: true },
      },
      modes: {
        grab: {
          distance: 140,
          links: { opacity: 0.15, color: "#22d3ee" },
        },
      },
    },
    particles: {
      color: { value: ["#ffffff", "#22d3ee", "#a5b4fc"] },
      number: {
        value: 80,
        density: { enable: true, area: 900 },
      },
      opacity: {
        value: { min: 0.1, max: 0.7 },
        animation: {
          enable: true,
          speed: 0.8,
          minimumValue: 0.05,
          sync: false,
        },
      },
      size: {
        value: { min: 0.5, max: 2.2 },
        animation: {
          enable: true,
          speed: 1.5,
          minimumValue: 0.3,
          sync: false,
        },
      },
      move: {
        enable: true,
        speed: 0.3,
        direction: "none",
        random: true,
        straight: false,
        outModes: { default: "out" },
      },
      links: {
        enable: false,
      },
      shape: { type: "circle" },
    },
    pauseOnBlur: true,
    pauseOnOutsideViewport: true,
  }), []);

  const particlesInit = useCallback((engine) => {
    loadFull(engine);
  }, []);

  return <Particles id={props.id} init={particlesInit} options={options} />;
};

export default ParticlesBackground;
